import { useState } from "react"

const useLocalStorage = (key : string, initialValue : any) => {
  const [state, setState] = useState(() => {
    // Initialize the state
    try {
      const value = typeof window !== "undefined" && window.localStorage.getItem(key)
      return value ? JSON.parse(value) : initialValue
    } catch (error) {
      console.log(error)
      throw new Error('local storage error')
    }
  })

  const setValue = (value : any)  => {
    try {
      const valueToStore = value instanceof Function ? value(state) : value
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
      setState(value)
    } catch (error) {
      console.log(error)
      throw new Error('local storage error')
    }
  }

  

  return [state, setValue]
}

export default useLocalStorage